import { render, staticRenderFns } from "./EditarPercepcionCargasFamilia.vue?vue&type=template&id=717c4fec&scoped=true&"
import script from "./EditarPercepcionCargasFamilia.vue?vue&type=script&lang=js&"
export * from "./EditarPercepcionCargasFamilia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717c4fec",
  null
  
)

export default component.exports